export default __webpack_public_path__ + "static/media/Gida of the Unholy Communion.d9684c61.jpg";